function SButton(props) {
    return (
        <button className="m-1 bg-cyan-600 hover:bg-cyan-700 text-cyan-50 font-bold py-1 px-4 rounded-full">{props.children}</button>
    )
  }

  export { SButton };